export const getAddressPayload = (address, deliveryMethod) => {
  let payload = {
    ...address,
    country: address?.country?.code,
    house_number: address?.house_number || '1',
    province: address?.province?.code,
  }

  if (!deliveryMethod?.requires_house_number) delete payload.house_number

  return payload
}

export const getSendInstructionsPayload = ({ returnLabels, invoices, transaction, customsDeclaration }) => {
  return {
    invoice: !!invoices?.find(invoice => invoice === transaction?.invoice_url),
    exchange_for_order_invoice: !!invoices?.find(custom => custom === transaction?.exchanged_for_order?.invoice_url),
    return_label_ids: returnLabels,
    customs_declaration: customsDeclaration,
  }
}
